var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPopOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16 0a2 2 0 0 1 2 2v10a2 2 0 0 1-1.796 1.99L16 14h-1v-2h1V2H6v1H4V2a2 2 0 0 1 2-2h10Z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 8,
  x: 6,
  y: 7,
  fill: "currentColor",
  rx: 1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 8,
  x: 3,
  y: 12,
  fill: "currentColor",
  rx: 1,
  transform: "rotate(-90 3 12)"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  x: 1,
  y: 5,
  stroke: "currentColor",
  strokeWidth: 2,
  rx: 1
})));
export default SvgIconPopOut;